import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {Card, CardContent, Grid, Typography, Avatar, Button} from '@material-ui/core';
import PeopleIcon from '@material-ui/icons/PeopleOutlined';
import {formatNumber} from "helpers/formaters";
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.success.main,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: {
    color: theme.palette.success.dark
  },
  differenceValue: {
    color: theme.palette.success.dark,
    marginRight: theme.spacing(1)
  },
  button: {
    marginTop: theme.spacing(2)
  }
}));

const ActiveAccounts = props => {
  const { className, activeAccountsCount, loading, ...rest } = props;

  const classes = useStyles();
  const navigate = useNavigate();
  const handleCreateAccount = () => {
    navigate('/accounts/new');
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              Active accounts
            </Typography>
            <div class={loading?"loading":""}>
              <Typography variant="h3">{formatNumber(activeAccountsCount, 0)}</Typography>
            </div>
          </Grid>

          <Grid item>
            <Avatar className={classes.avatar}>
              <PeopleIcon className={classes.icon} />
            </Avatar>
          </Grid>
        </Grid>

        <Grid container justifyContent="center"
              style={{ margin:'1em auto' }}>

          <Button
              sx={{textTransform: "none"}}
              variant="outlined"
              color="primary"
              size="small"
              onClick={handleCreateAccount}
          >
            Create Account
          </Button>


        </Grid>

      </CardContent>
    </Card>
  );
};

ActiveAccounts.propTypes = {
  className: PropTypes.string
};

export default ActiveAccounts;
